import React from "react";
import styled from "styled-components";

const Card = styled.article`
  width: 100%;
  border-radius: 16px;
  border: 1px solid #ece7f6;
  background: ${({ theme }) => theme.card};
  box-shadow: 0 10px 30px rgba(80, 40, 140, 0.06);
  padding: 22px 22px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  @media (max-width: 640px) {
    padding: 16px;
  }
`;

const Top = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const Identity = styled.div`
  display: flex;
  gap: 14px;
  min-width: 0;
`;

const Image = styled.img`
  height: 58px;
  width: 58px;
  object-fit: contain;
  background: #fff;
  border-radius: 12px;
  padding: 4px;
  flex-shrink: 0;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const Name = styled.h3`
  font-size: 20px;
  font-weight: 600;
  line-height: 1.35;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 640px) {
    font-size: 17px;
  }
`;

const Degree = styled.div`
  font-size: 15px;
  font-weight: 500;
  line-height: 1.45;
  color: ${({ theme }) => theme.text_secondary};
`;

const Date = styled.div`
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.primary};
  background: ${({ theme }) => theme.primary}22;
  border-radius: 999px;
  padding: 6px 12px;
  white-space: nowrap;
`;

const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Chip = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  border: 1px solid ${({ theme }) => theme.primary}66;
  border-radius: 999px;
  padding: 4px 10px;
`;

const Description = styled.p`
  font-size: 15px;
  line-height: 1.65;
  color: ${({ theme }) => theme.text_primary}cc;
`;

const EducationCard = ({ education }) => {
  return (
    <Card>
      <Top>
        <Identity>
          <Image src={education.img} alt="" />
          <Body>
            <Name>{education.school}</Name>
            <Degree>{education.degree}</Degree>
          </Body>
        </Identity>
        <Date>{education.date}</Date>
      </Top>
      <Meta>
        <Chip>
          {education.gradeLabel || "Grade"}: {education.grade}
        </Chip>
      </Meta>
      <Description>{education.desc}</Description>
    </Card>
  );
};

export default EducationCard;
